import { cityParser } from '@/plugins/city_parser';
import { Vue, Component } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

@Component({})
export default class SuperCategoriesNavigator extends Vue {

  // Getters
  @Getter getCity;
  @Getter getCurrentSuperCategory;
  @Getter getIsUnderMobile;
  
  // Mutations
  @Mutation CURRENT_SUPER_CATEGORY;

  get getSuperCategories() {
    let response = [];
    if(this.getCity && this.getCity.super_categories) {
      response = this.getCity.super_categories;
    }
    return response;
  }

  get nextSuperCategory() {
    let response = null;
    if(this.getCurrentSuperCategory && this.getCurrentSuperCategory.id) {
      for (let i = 0; i < this.getSuperCategories.length && !response; i++) {
        const sc = this.getSuperCategories[i];
        if (sc.id === this.getCurrentSuperCategory.id) {
          if (i + 1 === this.getSuperCategories.length) {
            response = this.getSuperCategories[0];
          } else {
            response = this.getSuperCategories[i + 1];
          }
        }
      }
    } else {
      response = this.firstSuperCategory;
    }
    return response;
  }

  get previousSuperCategory() {
    let response = null;
    if(this.getCurrentSuperCategory && this.getCurrentSuperCategory.id) {
      for (let i = 0; i < this.getSuperCategories.length && !response; i++) {
        const sc = this.getSuperCategories[i];
        if (sc.id === this.getCurrentSuperCategory.id) {
          if (i - 1 < 0) {
            response = this.getSuperCategories[this.getSuperCategories.length - 1];
          } else {
            response = this.getSuperCategories[i - 1];
          }
        }
      }
    } else {
      response = this.lastSuperCategory;
    }
    return response;
  }

  get lastSuperCategory() {
    let response = null;
    if(this.getSuperCategories && this.getSuperCategories.length) {
      response = this.getSuperCategories[this.getSuperCategories.length - 1];
    }
    return response;
  }

  get firstSuperCategory() {
    let response = null;
    if(this.getSuperCategories && this.getSuperCategories.length) {
      response = this.getSuperCategories[0];
    }
    return response;
  }

  _onSetSuperCategory(superCategory) {
    this.CURRENT_SUPER_CATEGORY(superCategory);
    try {
      this.$router.push({ name: 'superCategories', query: {
        pasillo: cityParser(superCategory.name)
      }});
    } catch (error) {
      // Do nothing
    }
  }

  _trim(value: string) {
    let response = value;
    if(this.getIsUnderMobile && response.length > 20) {
      response = value.substr(0, 20) + "...";
    }
    return response;
  }
}